import React, { useRef, Fragment, useState, useEffect, useMemo, } from 'react';
import { FormGroup, Label, InputGroup, Input, Button, Modal, ModalBody, ModalFooter, Form, } from 'reactstrap';
import { last, orderBy, chunk, groupBy, sum, sumBy, sortBy, isEmpty, pick, get, keyBy, omit, mapValues, } from 'lodash';
import { useDebounce, useToggle, useList, useCounter, } from 'react-use';
import { toast, } from 'react-toastify';
import { Link, } from 'react-router-dom';
import { format as formatDate } from 'date-fns';
import Select from 'react-select';
import jsbarcode from 'jsbarcode';
import { PDFDocument, } from 'pdf-lib';
import { jsPDF } from 'jspdf';
import dedent from 'dedent';
import { parse as parseCsv } from 'papaparse';
import classnames from 'classnames';
import fileDownload from 'js-file-download';

import env from '../../env';
import { drawAmazonProductLabel, drawFnskuLabelsTitleLabel, } from '../../label';
import okSoundSrc from '../../sounds/ok.mp3';
import ngSoundSrc from '../../sounds/ng.mp3';
import locationChangeSoundSrc from '../../sounds/location-change.wav';
import firebase, { functions } from '../../firebase';

import { isMobile, safePrefix, } from '../../util';
import { fieldDisplayValue, serial, } from '../../shared/util';
import { drawGbAmazonShippingLabel, drawFukuyamaAmazonShippingLabel, } from '../../label';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import EditButton from '../EditButton';
import { prefectures, } from '../../shared/config';
import { idWithTenant, } from '../../shared/util';
import { fields as shippingRequestFields, computeGBFcSortNumber, computeDocumentNumberForBarcode, formatPlanOfShippingRequest, } from '../../shared/models/shippingRequest';
import { statuses, } from '../../shared/models/inventory';
import ReceivingRequestDetailModal from './ReceivingRequestDetailModal';
import ListForm from '../ListForm';
import ShippingRequestFormModal from './ShippingRequestFormModal';
import InboundShipmentCompleteFormModal from './InboundShipmentCompleteFormModal';
import ProgressButton from '../ProgressButton';
import PendingItemForm from '../forms/PendingItemForm';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import useCollectionsSubscription from '../hooks/useCollectionsSubscription';
import useCollectionsFetch from '../hooks/useCollectionsFetch';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import { ResponsiveTableRow, ResponsiveTableColumn } from '../ResponsiveTable';

const scales = {
  gb: 10,
  fukuyama: 20,
};
const labelSizes = {
  gb: { width: 80, height: 115, },
  fukuyama: { width: 105, height: 162, },
};
const { entries, keys, } = Object;
const fetchFbaLabels = functions.httpsCallable('fetchFbaLabels');
const printBarcode = functions.httpsCallable('printBarcode', { timeout: 550000, });
const completeInboundShipment = functions.httpsCallable('completeInboundShipment', { timeout: 550000, });
const completeShopifyShipment = functions.httpsCallable('completeShopifyShipment');
const completeRakutenShipment = functions.httpsCallable('completeRakutenShipment');
const completeYahooShipment = functions.httpsCallable('completeYahooShipment');
const completeTtsShipment = functions.httpsCallable('completeTtsShipment');
const completeMercariShipment = functions.httpsCallable('completeMercariShipment');
const completeQoo10Shipment = functions.httpsCallable('completeQoo10Shipment');
const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const inventoriesRef = db.collection('inventories');
const shippingRequestsRef = db.collectionGroup('shippingRequests');
const printersRef = db.collection('printers');

export default function ShippingFormModal(props) {
  const { user, type, isOpen, locations, } = props;

  const textValueInput = useRef(null);

  // DEV
  // const [textValue, setTextValue] = useState('FBA15FBCM8WM');
  const [textValue, setTextValue] = useState('');

  const ref = textValue && shippingRequestsRef.where(...(type === 'amazon' ? ['plan.ShipmentId', '==', textValue] : ['documentNumbers', 'array-contains', textValue]));
  const matchedShippedRequests = useCollectionSubscription(ref, [textValue]);
  // DEBUG
  // const matchedShippedRequest = matchedShippedRequests.find(_ => _.status === 'processing');
  const matchedShippedRequest = orderBy(matchedShippedRequests, _ => _.createdAt.toDate(), 'desc')[0];

  const onClickClose = () => {
    if(!isEmpty(textValue) && matchedShippedRequest != null) {
      if(
        !window.confirm(dedent`
          ピッキングがすべて完了しましたか？
          ピッキングが完了した場合は必ず「完了」より処理してください。

          本当にこの画面を閉じますか？
        `)
      ) return;

      props.onClickClose();
    } else {
      props.onClickClose();
    }
  };
  const onCompleted = () => {
    setTextValue('');
    textValueInput.current.focus();
  };
  useEffect(() => {
    if(matchedShippedRequest == null) return;

    if((matchedShippedRequest.inventoryIds || []).length === sumBy(matchedShippedRequest.items, _ => (_.goodQuantity || _.ngQuantity))) {
      // setTextValue('');
    }
  }, [matchedShippedRequests]);

  return (
    <Modal isOpen={isOpen} style={{ minWidth: !isMobile() && 1000 }}>
      <div className="modal-header">
        <div className="w-100 d-flex justify-content-between">
          <h5 className="modal-title">
            出荷処理
          </h5>
        </div>
      </div>
      <ModalBody>
        <FormGroup>
          <Label>{type === 'amazon' ? 'FBA配送番号' : '伝票番号'}</Label>
          <Input innerRef={textValueInput} value={textValue} onChange={_ => setTextValue(_.target.value)} />
        </FormGroup>
        {
          !isEmpty(textValue) && (
            matchedShippedRequest != null ? (
              <ShippingRequestCard user={user} shippingRequest={matchedShippedRequest} locations={locations} type={type} onCompleted={onCompleted} />
            ) : (
              <div className="text-danger">
                出荷依頼が見つかりません
              </div>
            )
          )
        }
      </ModalBody>
      <ModalFooter>
        <Button className="cancel" color="secondary" onClick={onClickClose}>閉じる</Button>
      </ModalFooter>
    </Modal>
  );
};

function ShippingRequestCard (props) {
  const { user, type, locations, shippingRequest, onCompleted, } = props;
  const planItemsBySku = keyBy(shippingRequest.plan?.items, 'msku');
  const [currentPrinterId, selectPrinterId] = useState(null);
  const [debugData, setDebugData] = useState({ prevInventories: [], });
  const [quantity, setQuantity] = useState(1);
  const isInvalidQuantity = quantity != null && (quantity <= 0 || quantity > 400);
  const ngAudioEl = useRef(null);
  const okAudioEl = useRef(null);
  const locationChangeAudioEl = useRef(null);
  const locationIds = locations.map(_ => _.id);
  const locationsById = keyBy(locations, 'id');
  const [hasCheckedOptions, toggleHasCheckedOptions] = useToggle(false);
  const [isProcessing, toggleProcessing] = useToggle(false);
  const [isFinishing, toggleFinishing] = useToggle(false);
  const [showsAll, toggleShowsAll] = useToggle(false);
  const [prevMatchedInventoryLocationId, setPrevMatchedInventoryLocationId] = useState(null);
  const tenantRef = shippingRequest.ref.parent.parent;
  const tenant = useDocumentSubscription(tenantRef, [shippingRequest]);
  const sender = useDocumentSubscription(tenantRef.collection('senders').doc(shippingRequest.senderId), [shippingRequest]);
  const printers = useCollectionSubscription(printersRef.orderBy('createdAt'));
  const printersById = keyBy(printers, 'id');
  const printerOptions = [{ label: '(規定プリンター)', value: null }, ...printers.map(_ => ({ label: _.name, value: _.id }))];
  let sortedPickedInventoriesRef = inventoriesRef.where('tenantId', '==', tenantRef.id).where('shippingRequestId', '==', shippingRequest.id).where('status', 'in', ['picked', 'shipped']).orderBy('createdAt');
  if(!showsAll) sortedPickedInventoriesRef = sortedPickedInventoriesRef.limit(showsAll ? 100000 : 3)
  const sortedPickedInventories = useCollectionSubscription(sortedPickedInventoriesRef, [shippingRequest.id, showsAll]);
  const pickedInventoriesCounts = shippingRequest.items.reduce((x, { productId }) => {
    return { ...x, [productId]: (shippingRequest[['inventoryIds', productId].join('-')] || []).length, };
  }, {});
  const totalPickedCount = sum(Object.values(pickedInventoriesCounts));
  const itemsWithCandidateCount = shippingRequest.items.map(_ => ({ ..._, candidateCount: (_.goodQuantity || _.ngQuantity) - get(pickedInventoriesCounts, [_.productId], 0) }));
  const totalRequiredCount = sumBy(shippingRequest.items, _ => _.goodQuantity || _.ngQuantity);
  // NOTE 商品名・バーコード照合等に利用
  const products = useCollectionsSubscription(chunk(shippingRequest.items, 10).map(items => tenantRef.collection('products').where(firebase.firestore.FieldPath.documentId(), 'in', items.map(_ => _.productId))), [shippingRequest?.id], { initialItems: null });
  const productsById = keyBy(products, 'id');
  const allocatedInventoryIds = Array.isArray(shippingRequest.allocatedInventoryIds) ? shippingRequest.allocatedInventoryIds : [];
  const allPickedIds = new Set(shippingRequest.items.flatMap(_ => shippingRequest[`inventoryIds-${_.productId}`] || []));
  const candidateProductIds = new Set(itemsWithCandidateCount.filter(_ => _.candidateCount > 0).map(_ => _.productId));
  const candidateIds = allocatedInventoryIds.filter(_ => candidateProductIds.has(_.productId) && !allPickedIds.has(_.inventoryId)).map(_ => _.inventoryId);
  const { items: candidateInventories, isLoading } = useCollectionsFetch(
    chunk(candidateIds.slice(0, showsAll ? Infinity : 3), 10).map(_ => inventoriesRef.where(firebase.firestore.FieldPath.documentId(), 'in', _)),
    [shippingRequest.id, showsAll, totalPickedCount, JSON.stringify(allocatedInventoryIds)],
    { detail: true },
  );
  // NOTE: ロケ順 → 同一ロケ内は先入れ先出し(shelvedAt昇順)
  const sortedCandidateInventories = sortBy(candidateInventories.filter(_ => _.status === 'shelved'), [_ => _.locationKey ?? '', _ => _.shelvedAt?.toDate?.()?.getTime?.() ?? 0]);
  const isSatisfied = itemsWithCandidateCount.every(_ => _.candidateCount === 0);

  const sortedInventories = [...sortedCandidateInventories, ...sortedPickedInventories];
  const rowsContent = useMemo(() => {
    return (showsAll ? sortedInventories : sortedInventories.slice(0, 3)).map((inventory, i) => {
      const { id, ref, locationId, productId } = inventory;
      const location = locationsById[locationId];
      const product = productsById[productId];

      return location != null && product != null && (
        <Row key={i} {...{ id, inventoryRef: ref, shippingRequest, location, product, inventory, }} />
      );
    });
  }, [showsAll, products, locations, sortedInventories.map(_ => _.id).join('')]);

  const [count, setCount] = useState(1);
  const [barcodeValue, setBarcodeValue] = useState('');
  const onChangeBarcodeInfoValue = async (e) => {
    setBarcodeValue(e.target.value);
  };
  const playAudio = (audio) => {
    audio.currentTime = 0;
    audio.play();
  };
  useDebounce(async (e) => {
    if(isEmpty(barcodeValue)) return;

    setBarcodeValue('');
    setQuantity(1);
    if(shippingRequest.type === 'return' ? !barcodeValue.match(/-N$/) : barcodeValue.match(/-N$/)) return playAudio(ngAudioEl.current);

    const matchedProduct = products?.find(_ => [_.fnsku, idWithTenant(_.ref), _.barcodeInfo].includes(safePrefix(barcodeValue).replace(/-N$/, '')));
    if(matchedProduct == null) return playAudio(ngAudioEl.current);
    if(type === 'amazon' && !matchedProduct.isCase && barcodeValue.match(/\d+-\d+/)) return playAudio(ngAudioEl.current);

    const matchedInventories = user.enablesShippingWithQuantity ? sortedCandidateInventories.filter(_ => _.productId === matchedProduct.id).slice(0, quantity) : sortedCandidateInventories.slice(0, 1).filter(_ => _.productId === matchedProduct.id);
    if(matchedInventories.length < quantity) return playAudio(ngAudioEl.current);

    toggleProcessing(true);
    const batch = db.batch();
    matchedInventories.map((matchedInventory) => {
      batch.update(matchedInventory.ref, {
        shippingRequestId: shippingRequest.id,
        pickedAt: new Date(),
        status: 'picked',
      });
    });
    batch.update(matchedProduct.ref, {
      ngInventoryIds: firebase.firestore.FieldValue.arrayRemove(...matchedInventories.map(_ => _.id)),
      goodInventoryIds: firebase.firestore.FieldValue.arrayRemove(...matchedInventories.map(_ => _.id)),
    });
    batch.update(shippingRequest.ref, {
      [['inventoryIds', matchedProduct.id].join('-')]: firebase.firestore.FieldValue.arrayUnion(...matchedInventories.map(_ => _.id)),
      inventoryIds: firebase.firestore.FieldValue.arrayUnion(...matchedInventories.map(_ => _.id)),
    });
    setDebugData({ prevInventories: [...debugData.prevInventories, ...matchedInventories], });
    await batch.commit();
    toggleProcessing(false);
    setPrevMatchedInventoryLocationId(last(matchedInventories).locationId);
    playAudio(okAudioEl.current);

    // 最後の1個を処理した場合、オプションがなければ完了確認を表示（Amazon以外）
    const newPickedCount = totalPickedCount + matchedInventories.length;
    const isLastItem = newPickedCount === totalRequiredCount;
    const hasNoOptions = isEmpty(shippingRequest.shippingOptionValues);

    if(type !== 'amazon' && isLastItem && hasNoOptions) {
      if(window.confirm('すべてのピッキングが完了しました。出荷を完了しますか？')) {
        await onClickCompleted();
      }
    }
  }, 300, [barcodeValue]);
  const onClickUndo = async () => {
    const { prevInventories } = debugData;
    await Promise.all(prevInventories.map(async (prevInventory) => {
      const batch = db.batch();
      batch.update(prevInventory.ref, { shippingRequestId: null, pickedAt: null, status: 'shelved', });
      batch.update(tenantsRef.doc(prevInventory.tenantId).collection('products').doc(prevInventory.productId), {
        [prevInventory.isNg ? 'ngInventoryIds' : 'goodInventoryIds']: firebase.firestore.FieldValue.arrayUnion(prevInventory.id),
      });
      batch.update(shippingRequest.ref, {
        [['inventoryIds', prevInventory.productId].join('-')]: firebase.firestore.FieldValue.arrayRemove(prevInventory.id),
        inventoryIds: firebase.firestore.FieldValue.arrayRemove(prevInventory.id),
      });
      await batch.commit();
    }));
    setDebugData({ prevInventories: [], });
    playAudio(okAudioEl.current);
  };
  const onClickPrintBarcode = async (type) => {
    const scale = scales[type];
    const { width: labelWidth, height: labelHeight, } = labelSizes[type];
    const barcodeX = 35;
    const barcodeW = 40;
    const message = dedent`
      すべての商品がピッキングが完了していません。
      商品が不足している場合は必ず責任者へ報告してください。
      本当にラベルを発行しますか？
    `;
    if(!isSatisfied && !window.confirm(message)) return;

    try {
      const amazonFcData = parseCsv(await fetch('https://docs.google.com/spreadsheets/d/e/2PACX-1vQX1N_I6YTt_Mnu2oz26YKQR-_YLgTQNk5V1l7z366yXJ0AFDNDeFPmaNaqAqAeApNHqU8xZqpApFOr/pub?gid=664712221&single=true&output=csv').then(_ => _.text()), { header: true }).data;
      // NOTE: FCマスタ未登録のAmazon倉庫だとラベル描画で落ちるため、事前に原因を明示して中断する
      const fcId = formatPlanOfShippingRequest(shippingRequest).plan.DestinationFulfillmentCenterId;
      const amazonFcDataItem = amazonFcData.find(_ => _['コード'] === fcId);
      const missingFcReason = (
        amazonFcDataItem == null ? 'Amazon FCマスタに登録されていません' :
        type === 'gb' && isEmpty(amazonFcDataItem['GBナンバー']) ? 'Amazon FCマスタのGBナンバーが未設定です' :
        type === 'fukuyama' && isEmpty(amazonFcDataItem['福通着店コード']) ? 'Amazon FCマスタの福通着店コードが未設定です' :
        null
      );
      if(missingFcReason != null) {
        return void toast.error(`ラベルを発行できません。倉庫コード ${fcId || '(不明)'} が${missingFcReason}。担当者へマスタの追加・修正を依頼してください。`, { autoClose: false, });
      }

      await serial(chunk(Array(count).fill(), 10), async (ns, i) => {
        const allPdfDoc = await PDFDocument.create();
        await serial(ns, async (_, i2) => {
          const canvas = document.createElement('canvas');
          canvas.width = labelWidth * scale;
          canvas.height = labelHeight * scale;
          const draw = ({
            gb: drawGbAmazonShippingLabel,
            fukuyama: drawFukuyamaAmazonShippingLabel,
          })[type];
          draw(amazonFcData, canvas, scale, labelWidth, labelHeight, tenant, sender, shippingRequest, count, i * 10 + i2, barcodeX, barcodeW);
          const imageData = canvas.toDataURL('image/jpeg', 0.2);
          const doc = new jsPDF({ format: [labelWidth, labelHeight] });
          doc.addImage(imageData, 'JPEG', 0, 0, labelWidth, labelHeight);
          const pdfData = doc.output('datauri');
          const pdfDoc = await PDFDocument.load(pdfData);
          const [page] = await allPdfDoc.copyPages(pdfDoc, keys(pdfDoc.getPages()));
          await allPdfDoc.addPage(page);
        });
        const content = await allPdfDoc.saveAsBase64({ dataUri: true })
        const { data: printResult } = await printBarcode({
          type: 'amazonProductShipment',
          title: `ShippingRequest Amazon ShipmentId ${shippingRequest.id}`,
          imageData: content,
          printnodePrinterId: printersById[currentPrinterId]?.printnodePrinterId,
        });
        if(printResult?.reason != null) throw new Error(printResult.reason);
        // DEV
        // TMP
        // const blob = new Blob([await allPdfDoc.save()], { type: 'application/pdf' });
        // window.open(URL.createObjectURL(blob));
      });
      await shippingRequest.ref.update({ amazonLabelsCount: count });
      toast.success('ラベル発行しました');
    } catch(e) {
      console.error(e);
      toast.error(`失敗しました (${e.message})`);
    }
  };
  const onClickPrintFbaLabels = async () => {
    if(!window.confirm('FBAラベルを印刷・ダウンロードします')) return;

    try {
      const { data: { url, base64Data } } = await fetchFbaLabels({ tenantId: shippingRequest.ref.parent.parent.id, shippingRequestId: shippingRequest.id, count, });
      
      const { data: printResult } = await printBarcode({
        type: 'amazonProductShipment',
        title: `FBA Labels ${shippingRequest.id}`,
        imageData: base64Data,
        printnodePrinterId: printersById[currentPrinterId]?.printnodePrinterId,
      });
      if(printResult?.reason != null) throw new Error(printResult.reason);
      
      window.open(url);
      
      toast.success('FBAラベル印刷・ダウンロードしました');
    } catch(e) {
      console.error(e);
      toast.error(`失敗しました (${e.message})`);
    }
  };
  const barcodeFieldLabel = type === 'amazon' ? 'FNSKU(ケースは商品ラベル)' : '商品バーコードまたはJANコード';

  // DEV
  //        useEffect(() => {
  //          if(shippingRequest && tenant && sender) {
  //            const canvas = document.getElementById('canvas');
  //            drawFukuyamaAmazonShippingLabel(canvas, scales.fukuyama, labelSizes.fukuyama.width, labelSizes.fukuyama.height, tenant, sender, shippingRequest, count, 0, 35, 40, true);
  //          }
  //        }, [shippingRequest, tenant, sender]);

  const onClickCompleted = async () => {
    toggleFinishing(true);
    try {
      if(type === 'amazon' || ['shopifySource', 'rakutenSource', 'yahooSource', 'ttsSource', 'mercariSource', 'qoo10Source'].some(_ => shippingRequest?.[_])) {
        if(type === 'amazon' && !window.confirm('本当に出荷済みにしますか？')) return;

        const complete = type === 'amazon' ? (
          completeInboundShipment
        ) : shippingRequest.shopifySource ? (
          completeShopifyShipment
        ) : shippingRequest.rakutenSource ? (
          completeRakutenShipment
        ) : shippingRequest.yahooSource ? (
          completeYahooShipment
        ) : shippingRequest.ttsSource ? (
          completeTtsShipment
        ) : shippingRequest.mercariSource ? (
          completeMercariShipment
        ) : shippingRequest.qoo10Source ? (
          completeQoo10Shipment
        ) : _ => _;
        const { data: error } = await complete({ tenantId: tenant.id, shippingRequestId: shippingRequest.id, count, });
        if(error) {
          if(error.message.includes('no updates can be made to this shipment')) {
            toast.warn('Amazonの納品の完了処理に、すでに変更できない旨のエラーが発生しましたが、完了処理は継続しました。');
          } else if(
            error.message.includes('Invalid LabelPrepPreference Provided')
            || error.message.includes('has not been provided')
          ) {
            toast.warn(`「${error.message}」のエラーが発生しましたが、完了処理は継続しました。`);
          } else {
            throw new Error(error.message);
          }
        }
        if(type === 'amazon') {
          await shippingRequest.ref.update({
            status: 'shipped',
            shippingItems: shippingRequest.shippingItems.map(_ => ({ ..._, shippedOn: new Date() })),
            completedAt: new Date(),
            ...(type === 'amazon' && count > 0 && { amazonLabelsCount: count, }),
          });
        }
        toast.success('完了しました');
      }
      await onCompleted();
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
    toggleFinishing(false);
  };
  const processValues = (values) => {
    return {
      ...values,
      documentNumbers: values.shippingItems.map(_ => _.documentNumber).filter(_ => _),
    };
  };
  useEffect(() => {
    const firstCandidateInventory = sortedCandidateInventories[0];
    if(firstCandidateInventory != null && prevMatchedInventoryLocationId != null && firstCandidateInventory.locationId !== prevMatchedInventoryLocationId) {
      playAudio(locationChangeAudioEl.current);
      setPrevMatchedInventoryLocationId(firstCandidateInventory.locationId);
    }
  }, [sortedCandidateInventories]);
  const onClickPrintFnskuLabels = async () => {
    if(!window.confirm('未ピッキングの在庫のFNSKUラベルを一括発行します。よろしいですか？')) return;

    try {
      const labelWidth = 52.5;
      const labelHeight = 29.7;
      const allPdfDoc = await PDFDocument.create();
      const allCandidateIds = allocatedInventoryIds.filter(_ => candidateProductIds.has(_.productId) && !allPickedIds.has(_.inventoryId)).map(_ => _.inventoryId);
      const allCandidateInventories = (await Promise.all(allCandidateIds.map(_ => inventoriesRef.doc(_).get()))).filter(_ => _.exists).map(_ => ({ id: _.id, ref: _.ref, ..._.data() }));
      const sortedCandidateInventories = sortBy(allCandidateInventories, [_ => _.locationKey ?? '', _ => _.shelvedAt?.toDate?.()?.getTime?.() ?? 0]);
      await serial(Object.values(groupBy(sortedCandidateInventories, _ => [_.locationKey, _.productId].join('__'))), async (inventories) => {
        const [{ locationKey, productId, }] = inventories;
        const product = productsById[productId];
        await (async () => {
          const canvas = document.createElement('canvas');
          const scale = 10;
          canvas.width = labelWidth * scale;
          canvas.height = labelHeight * scale;
          drawFnskuLabelsTitleLabel(canvas, scale, labelWidth, labelHeight, locationKey, product, inventories.length);
          const imageData = canvas.toDataURL('image/jpeg', 0.2);
          const doc = new jsPDF({
            orientation: 'landscape',
            format: [labelWidth, labelHeight]
          });
          doc.addImage(imageData, 'JPEG', 0, 0, labelWidth, labelHeight);
          const pdfData = doc.output('datauri');
          const pdfDoc = await PDFDocument.load(pdfData);
          const [page] = await allPdfDoc.copyPages(pdfDoc, keys(pdfDoc.getPages()));
          await allPdfDoc.addPage(page);
        })();
        const canvas = document.createElement('canvas');
        drawAmazonProductLabel(canvas, labelWidth, labelHeight, product, false);
        const imageData = canvas.toDataURL('image/jpeg', 0.2);
        const doc = new jsPDF({
          orientation: 'landscape',
          format: [labelWidth, labelHeight]
        });
        doc.addImage(imageData, 'JPEG', 0, 0, labelWidth, labelHeight);
        const pdfData = doc.output('datauri');
        const pdfDoc = await PDFDocument.load(pdfData);
        await serial(inventories, async (_, i) => {
          const [page] = await allPdfDoc.copyPages(pdfDoc, keys(pdfDoc.getPages()));
          await allPdfDoc.addPage(page);
        });
      });

      const content = await allPdfDoc.saveAsBase64({ dataUri: true })
      fileDownload(await allPdfDoc.save(), `${idWithTenant(shippingRequest.ref)}.pdf`);
    } catch(e) {
      console.error(e);
      toast.error('失敗しました');
    }
  };

  return (
    <div>
      <hr />
      <h5>
        見つかった出荷依頼
      </h5>
      <div>
        {
          // DEV
          // <canvas id="canvas" width={labelSizes.fukuyama.width * scales.fukuyama} height={labelSizes.fukuyama.height * scales.fukuyama} />
        }
        <div className="d-flex justify-content-between align-items-end gap-3">
          <div>
            <h4>
              {idWithTenant(shippingRequest.ref)}
            </h4>
            <div className="d-flex gap-2">
              オプション: {fieldDisplayValue(shippingRequest.shippingOptionValues, shippingRequestFields({ type: shippingRequest.type || 'normal', }).shippingOptionValues)}
              {
                !isEmpty(shippingRequest.shippingOptionValues) && (
                  <FormGroup check>
                    <Label check>
                      <Input type="checkbox" checked={hasCheckedOptions} onChange={_ => toggleHasCheckedOptions(_.target.checked)} />
                      <span className="font-weight-bold">
                        OK
                      </span>
                    </Label>
                  </FormGroup>
                )
              }
            </div>
            <div className="d-flex mt-1 gap-2">
              <FormGroup check>
                <Label check>
                  <Input type="checkbox" checked={showsAll} onChange={_ => toggleShowsAll(_.target.checked)} />
                  すべて表示
                </Label>
              </FormGroup>
            </div>
          </div>
          <div className="d-flex align-items-end gap-1">
            <div style={{ width: 200 }}>
              <Select
                options={printerOptions}
                value={printerOptions.find(_ => _.value === currentPrinterId)}
                onChange={_ => selectPrinterId(_?.value)}
                className="w-100"
              />
            </div>
            <FormGroup className={!user.enablesShippingWithQuantity && 'd-none'}>
              <Label className="small text-muted">数量</Label>
              <Input type="number" className={classnames('text-right', { 'is-invalid': isInvalidQuantity })} step="1" max={400} value={quantity} onChange={_ => setQuantity(_.target.value === '' ? null : parseInt(_.target.value, 10))} style={{ width: 'auto' }} />
            </FormGroup>
            <FormGroup className="m-0">
              <Label className="small text-muted">{barcodeFieldLabel}</Label>
              <Input value={barcodeValue} onChange={onChangeBarcodeInfoValue} autoFocus readOnly={isProcessing || isLoading} disabled={isInvalidQuantity} />
            </FormGroup>
          </div>
        </div>
        {
          type === 'amazon' && (
            <div className="mt-1 d-flex justify-content-end align-items-end gap-1">
              <ProgressButton process={onClickPrintFnskuLabels}>
                FNSKUラベル一括発行
              </ProgressButton>
            </div>
          )
        }
        <div className="d-flex justify-content-end mt-1">
          <div>
            {totalPickedCount} / {totalRequiredCount} ({totalRequiredCount - totalPickedCount})
          </div>
        </div>
        <div className="overflow-auto mb-2" style={{ maxHeight: 'calc(100vh - 400px)', }}>
          <table className={`table ${isMobile() ? '' : 'table-bordered'}`}>
            {
              !isMobile() && (
                <thead>
                  <tr>
                    <th style={{ minWidth: 80 }}>棚キー</th>
                    <th style={{ minWidth: 80 }}>バーコード</th>
                    <th style={{ minWidth: 100 }}>状態</th>
                    <th style={{ minWidth: 150 }}>商品名</th>
                    <th style={{ minWidth: 150 }}>期限</th>
                  </tr>
                </thead>
              )
            }
            <tbody>
              {rowsContent}
            </tbody>
          </table>
        </div>
        {
          type === 'amazon' && (
            <div className="d-flex mb-3">
              <div style={{ width: 200 }}>
                <Input type="number" value={count} onChange={_ => setCount(parseInt(_.target.value, 10))} />
              </div>
              <Button size="sm" className="ml-1" onClick={onClickPrintBarcode.bind(null, 'gb')}>
                GBラベル
              </Button>
              <Button size="sm" className="ml-1" onClick={onClickPrintBarcode.bind(null, 'fukuyama')}>
                福山ラベル
              </Button>
              <Button size="sm" className="ml-1" onClick={onClickPrintFbaLabels}>
                FBAラベル
              </Button>
            </div>
          )
        }
        {
          user.dev && (
            <ProgressButton color="warning" disabled={isEmpty(debugData.prevInventories)} process={onClickUndo}>
              Undo
            </ProgressButton>
          )
        }
        {
          type === 'amazon' && (
            <Fragment>
              <EditButton className="mr-1" label={false} itemRef={shippingRequest.ref} processValues={_ => ({ ..._, documentNumbers: _.shippingItems.map(_ => _.documentNumber).filter(_ => _)})} FormModal={ShippingRequestFormModal} formProps={{ tenant, products: [], admin: true, onlyShippingItems: true, }} />
              {count > 1 && <EditButton className="mr-1" label="内容詳細" itemRef={shippingRequest.ref} FormModal={InboundShipmentCompleteFormModal} formProps={{ tenant, shippingRequest, count, products: (products ?? []), productsById, }} />}
            </Fragment>
          )
        }
        <Button color="success" disabled={(!isEmpty(shippingRequest.shippingOptionValues) && !hasCheckedOptions) || !isSatisfied || isFinishing} onClick={onClickCompleted}>
          完了
        </Button>
      </div>
      <audio src={ngSoundSrc} ref={ngAudioEl} />
      <audio src={okSoundSrc} ref={okAudioEl} />
      <audio src={locationChangeSoundSrc} ref={locationChangeAudioEl} />
    </div>
  );
}

function Row (props) {
  const { id, inventoryRef, shippingRequest, location, product, } = props;
  const inventory = useDocumentSubscription(inventoryRef, [id]);
  const { label: statusLabel, shippingColor, } = statuses[inventory && inventory.status] || {};

  return inventory != null && (
    <ResponsiveTableRow data-id={id} key={id} className={isMobile() ? `position-relative bg-${shippingColor}` : `table-${shippingColor}`}>
      <ResponsiveTableColumn label="棚キー">
        {location.sortKey}
      </ResponsiveTableColumn>
      <ResponsiveTableColumn label="バーコード">
        {inventory.productBarcodeInfo}
      </ResponsiveTableColumn>
      <ResponsiveTableColumn label="状態">
        <span className={`badge badge-${shippingColor}`}>
          {get(statuses, [inventory.status, 'label'])}
        </span>
      </ResponsiveTableColumn>
      <ResponsiveTableColumn label="商品名">
        {product.isCase && <span className="badge badge-info mr-1">ケース</span>}
        {product.name}
        {product.sku && <div className="small text-muted">SKU: {product.sku}</div>}
      </ResponsiveTableColumn>
      <ResponsiveTableColumn label="期限">
        {inventory.expirationDate && formatDate(inventory.expirationDate.toDate(), 'yyyy/MM/dd')}
      </ResponsiveTableColumn>
      {
        isMobile() && ['picked', 'shipped'].includes(inventory.status) && (
          <div className="position-absolute d-flex align-items-center justify-content-end" style={{ top: 0, right: 0, bottom: 0, left: 0, }}>
            <div className="border rounded-circle border-danger text-danger d-flex align-items-center justify-content-center" style={{ width: 70, height: 70, fontSize: 40, marginRight: 30, }}>
              済
            </div>
          </div>
        )
      }
    </ResponsiveTableRow>
  );
}
